import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { AlertComponent } from '../../components/alert/alert.component';
import { IAlert } from '../../components/alert/alert.interface';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor(private snackBar: MatSnackBar) {}

  showSnackBarTopRight(data: IAlert, config?: MatSnackBarConfig) {
    this.snackBar.openFromComponent(AlertComponent, {
      data,
      duration: 5 * 1000,
      panelClass: ['!mt-[calc(var(--menu-top-height,0px)+5px)]'],
      verticalPosition: 'top',
      horizontalPosition: 'right',
      ...config,
    });
  }

  showSnackBarBottom(data: IAlert, config?: MatSnackBarConfig) {
    this.snackBar.openFromComponent(AlertComponent, {
      data,
      duration: 5 * 1000,
      panelClass: '!mb-[calc(var(--app-nav-menu-bottom-height,0px)+10px)]',
      ...config,
    });
  }
}
